module.exports = __webpack_public_path__ + "media/images/demo_tests/codecompare-79402a5af90bdb01e7a9273298eef56f.gif";